// extracted by mini-css-extract-plugin
module.exports = {"actual":"ReportModal_actual__3dE6o","notActual":"ReportModal_notActual__1yQsK"};